export const localStorageUserKey = 'user';
export const localStorageTokenKey = 'token';

export const authHeader = function() {
  // return authorization header with jwt token
  const token = userToken();

  if (token) {
    return {
      Authorization: `Bearer ${token}`,
    };
  }
  return {};
};

export const userToken = function() {
  return localStorage.getItem(localStorageTokenKey);
};

export const loggedIn = function() {
  return localStorage.getItem(localStorageTokenKey) !== null;
};
